export default {
  dateInputPattern: 'd{4}-d{1,2}-d{1,2}',
  minTenantAge: 18,
  maxTenantAge: 50,
  birthYearsAmount: 100,
  defaultAvatarUrl: 'anon.svg',
  listingFlexibleDays: 1,
};
